import React from 'react';
import { ILine } from '../../../global';
import Status from './Status';

interface LineStatusProps {
  line: ILine;
}

export default function LineStatus({ line }: LineStatusProps) {
  let status = line.status;
  let label: string;
  if (line.isChangeRequested) {
    status = 'changeRequest';
    label = 'Request';
  } else if (line.isSelling) {
    status = 'sellingGood';
    label = 'Selling';
  }
  return <Status status={status} label={label} />;
}
